import {
  ExtractFnReturnType,
  InfiniteQueryConfigType,
  useInfiniteQuery,
  UseInfiniteQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiManagersArchivedProvidingServicesIndexRequestType,
  ApiManagersArchivedProvidingServicesIndexResponseType,
} from "~/domains";

type RequestDataType = {
  params?: ApiManagersArchivedProvidingServicesIndexRequestType;
  page?: number;
};

const request = async ({
  params,
  page = 1,
}: RequestDataType): Promise<ApiManagersArchivedProvidingServicesIndexResponseType> => {
  const response =
    await new ApiClient().get<ApiManagersArchivedProvidingServicesIndexResponseType>(
      "/api/managers/archived_providing_services",
      { page, ...params },
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  params?: ApiManagersArchivedProvidingServicesIndexRequestType;
  config?: InfiniteQueryConfigType<QueryFnType>;
};

export const useApisManagersArchivedProvidingServicesIndex = ({
  params,
  config = {},
}: PropsType = {}): UseInfiniteQueryResult<ApiManagersArchivedProvidingServicesIndexResponseType> => {
  return useInfiniteQuery<ExtractFnReturnType<QueryFnType>>(
    ["ApisManagersArchivedProvidingServicesIndex", params],
    ({ pageParam }) => {
      return request({ params, page: pageParam as number | undefined });
    },
    {
      ...config,
      getNextPageParam: (data) => {
        return data.pagy.hasMore ? data.pagy.currentPage + 1 : false;
      },
    },
  );
};
